export default (str => str.replace( /(<([^>]+)>)/ig, ''));
